import { Node } from '@tiptap/react';

export const ComputeExpressionRootNode = Node.create({
  name: 'root',
  topNode: true,
  content: 'block',
});
